import PropTypes from 'prop-types';
import React from 'react';
import CurriculumLarge from './CurriculumLarge';
import CurriculumSmall from './CurriculumSmall';
import { stylesArr, stylesLarge, stylesSmall } from './CurriculumStyles';

const CurriculumTable = ({ content, display, small, style }) => {
  const smallLayout = (
    <CurriculumSmall content={content} display={display} styleObj={stylesSmall[style]} />
  );
  if (small) {
    return <div>{smallLayout}</div>;
  }
  return (
    <div className="curriculum-table">
      <div className="dn db-l pb2">{CurriculumLarge(content, display, stylesLarge[style])}</div>
      <div className="db dn-l">{smallLayout}</div>
    </div>
  );
};

CurriculumTable.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  ),
  display: PropTypes.shape({
    chords: PropTypes.bool,
    description: PropTypes.bool,
    lessons: PropTypes.bool,
    level: PropTypes.bool,
    minutes: PropTypes.bool,
    type: PropTypes.bool,
  }),
  small: PropTypes.bool,
  style: PropTypes.oneOf(stylesArr),
};

CurriculumTable.defaultProps = {
  content: [],
  display: {
    chords: true,
    level: true,
  },
  small: false,
  style: 'square',
};

export default CurriculumTable;
